'use strict';

$(document).ready(function () {
    /**
    * Adds a navbar sticky property to the top of the page
    */
    function stickyTop() {
        var $navElement = $('[data-sticky="stickyTop"]');
        if ($navElement.length > 0) {
            $('.experience-page').addClass('sticky-top');
            $navElement.closest('.experience-commerce_layouts-navRow').addClass('sticky-top');
        }
    }

    /**
    * Adds an active class to a link in a navbar if the anchor it links to is in viewport
    */
    function linkStatus() {
        var $navItems = $('.js-pd-nav-link');
        var $win = $(window);
        var $items = $('.anchor a');

        $win.on('scroll', function () {
            $.each($items, function (key, value) {
                var item = $(value);

                if ($win.scrollTop() >= item.offset().top - 100) {
                    var id = item.attr('name');

                    $('.js-pd-nav-link.active').removeClass('active');
                    $.each($navItems, function (k, v) {
                        var $navItem = $(v);
                        if ($navItem.attr('href') === '#' + id) {
                            $navItem.addClass('active');
                        }
                    });
                }
            });
        });
    }

    stickyTop();
    linkStatus();
});
